import items from '../../api/items'

export default {
    namespaced: true,
    state: {
        items: [],

        isLoaded: false,
    },
    mutations: {
        setItems: function(state, items) {
            state.items = items
            state.isLoaded = true
        },
    },

    getters: {
        state: state => state,

        isLoaded: state => {
            return state.isLoaded
        },

        isFound: state => {
            return state.isLoaded && state.items.length > 0
        },

        isNoresult: state => {
            return !state.isLoaded || state.items.length == 0
        },

        items: state => {
            return state.isLoaded ? state.items : []
        }
    },

    actions: {
        getRecent: function({commit, getters}, rownum) {
            if (rownum === void 0) rownnum = 3
            let params = {
                rownum: rownum
            }

            items.getRecent(params, res => {
                commit('setItems', res.data)
            })
        }
    }
}

